import { $api } from '@service/RequestService';
import { useQuery } from 'react-query';

import { kpiConstants, kpiModels } from '..';

export const useKpiConfig = (props?: { onSuccess?: (data: kpiModels.IKpiConfig) => void }) =>
  useQuery<kpiModels.IKpiConfig>({
    queryKey: [kpiConstants.queryKeys.KPI_CONFIG],
    queryFn: async () => {
      const res = await $api.get('/v1/kpi/config');

      return res?.data?.data;
    },
    onSuccess: props?.onSuccess
  });
